var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"formulaBox"}}),_c('custom-header',{ref:"customHeader",class:{'show-head': _vm.showHeader},on:{"login":_vm.login}}),_c('router-view',{ref:"main",on:{"initProject":_vm.initProject,"openFeedback":_vm.feedback,"openExpApply":_vm.expApply}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }